import React from 'react';
import { IconProps } from '../../icon/interfaces';
import InternalIcon from '../../icon/internal';
import styles from './styles.css.js';

const ItemIcon = (props: IconProps) => {
  return (
    <span className={styles.icon}>
      <InternalIcon {...props} />
    </span>
  );
};

export default ItemIcon;
